import { computed } from "vue";
import { useTrackingStore } from "../tracking.store";
import { IntercomService } from "@/services/tracking/intercom-service";

export function useIntercomService() {
  const trackingStore = useTrackingStore();

  const intercomService = computed(() =>
    trackingStore.hasServicesInitialized
      ? trackingStore.getService(IntercomService)
      : null,
  );

  return intercomService;
}
